import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import EmptyState from "../../components/EmptyState";
import StatusChip from "../../components/StatusChip";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { FileText } from "lucide-react";

// B5 part 2c: read-only list of every proposal (legacy + model 2). New proposals are created and sent from the
// opportunity page (one path: /api/sales); the legacy create/send routes answer 410. Existing records stay readable.
export default function Proposals() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/proposals").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);

  return (
    <AppShell title="Proposals" subtitle={`${items.length} proposal(s) · read-only list`}>
      <p className="mb-3 text-sm bg-erf-creamSecondary border border-erf-borderCream rounded p-3" role="note" data-testid="prop-one-path-note">
        Create and send proposals from the opportunity page (Proposal → contract → project). Older proposals made with the
        previous tool are listed here as “Legacy” and stay readable; client links already sent for them still work.
      </p>
      {items.length === 0 ? (
        <EmptyState icon={FileText} title="No proposals yet" subtitle="Open an opportunity with an approved estimate to create the proposal." />
      ) : (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Opportunity</th>
                <th className="text-left px-3 py-2">Kind</th>
                <th className="text-left px-3 py-2">Status</th>
                <th className="text-left px-3 py-2 mono">v</th>
                <th className="text-right px-3 py-2 mono">Total</th>
                <th className="text-left px-3 py-2">Client link</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-erf-borderCream/60" data-testid={`prop-row-${p.id}`}>
                  <td className="px-3 py-2 mono text-[11px]">{p.opportunity_id ? <Link to={`/crm/opportunities/${p.opportunity_id}`} className="underline inline-flex min-h-[44px] items-center" data-testid={`prop-open-${p.id}`}>{p.opportunity_id.slice(0, 8)}</Link> : "—"}</td>
                  <td className="px-3 py-2 text-[11px]" data-testid={`prop-kind-${p.id}`}>{p.model === 2 ? "Proposal (v2)" : "Legacy"}</td>
                  <td className="px-3 py-2"><StatusChip status={p.status === "sent" ? "connected" : p.status === "accepted" ? "verified" : "not_configured"} label={p.status} /></td>
                  <td className="px-3 py-2 mono">{p.model === 2 ? p.current_version_no : p.version}</td>
                  <td className="px-3 py-2 mono text-right">${Number(p.price_summary?.total || 0).toLocaleString()}</td>
                  <td className="px-3 py-2 text-[11px] text-erf-dark/60" data-testid={`prop-link-state-${p.id}`}>{p.status === "draft" ? "Not sent" : "Issued once at send (not stored)"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AppShell>
  );
}
